import { render } from "./VerificationHome.component.vue?vue&type=template&id=74a20674&scoped=true"
const script = {}

import "./VerificationHome.component.vue?vue&type=style&index=0&id=74a20674&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74a20674"]])

export default __exports__